import styles from './gk-input.module.scss';
import cx from 'classnames';

import AppearDown from '../../transitions/AppearDown/appear-down';

/**
 * TODO : renommber sans le 2 dans le nom, retirer le type InputType et appeler InputText.TEXT et autre dans les templates appelant le composant
 */
export enum InputType2 {
  TEXT = 'text',
  NUMBER = 'number',
  TEXTAREA = 'textarea',
  TEL = 'tel',
  MAIL = 'mail',
  RADIO = 'radio',
  MOBILE = 'mobile',
}

type InputType =
  | 'text'
  | 'number'
  | 'textarea'
  | 'tel'
  | 'email'
  | 'radio'
  | 'mobile'
  | 'url';

type DefaultValueType = string | number;

export interface GKInputProps {
  name: string;
  placeholder?: string;
  type?: string | InputType | InputType2;
  className?: string;
  required?: boolean;
  onChangeValue?: Function;
  defaultValue?: DefaultValueType;
  min?: number;
  max?: number;
  errors?: any;
  register?: Function;
  maxLength?: number;
  pattern?: any;
  onFocus?: Function;
  onBlur?: Function;
  fullWidth?: boolean;
  disabled?: boolean;
}

export const GKInput = (props: GKInputProps) => {
  const {
    name,
    placeholder = '',
    type = 'text',
    className,
    required = false,
    register,
    maxLength,
    min,
    max,
    onChangeValue,
    defaultValue = '',
    errors,
    pattern,
    onFocus,
    onBlur,
    fullWidth = false,
    disabled = false,
  } = props;

  const CustomTag = type !== 'textarea' ? 'input' : 'textarea';

  return (
    <div
      className={cx(
        styles['GKInput'],
        className,
        fullWidth && styles['fullWidth']
      )}
    >
      <div
        className={cx(
          styles['GKInput-container'],
          fullWidth && styles['fullWidth']
        )}
      >
        {register ? (
          <CustomTag
            name={name}
            disabled={disabled}
            type={type}
            {...register(name, {
              required: {
                value: required,
                message: 'Ce champ est requis',
              },
              pattern: {
                value: pattern,
                message: 'Ce champ nest pas valide',
              },
              maxLength: {
                value: maxLength,
                message: 'Ce champ est trop long',
              },
            })}
            min={min}
            max={max}
            defaultValue={defaultValue || ''}
            placeholder={placeholder}
            onFocus={onFocus}
            onBlur={onBlur}
            autoComplete="off"
          />
        ) : (
          <CustomTag
            autoComplete="off"
            disabled={disabled}
            name={name}
            type={type}
            onChange={(e) => {
              onChangeValue && onChangeValue(e);
            }}
            min={min}
            max={max}
            maxLength={maxLength}
            defaultValue={defaultValue || ''}
            placeholder={placeholder}
            onFocus={() => onFocus && onFocus()}
            onBlur={() => onBlur && onBlur()}
          />
        )}
      </div>

      <div>
        {errors && (
          <AppearDown isActive={errors[name]} duration=".3s">
            <span className="form-msg is-error">{errors[name]?.message}</span>
          </AppearDown>
        )}
      </div>
    </div>
  );
};

export default GKInput;
